import { jsx as _jsx } from "react/jsx-runtime";
/**
 * CommunicationHub - Admin Communication Center
 *
 * Uses TabHub to display all inquiries (contact + price) with tab navigation.
 */
import { useState } from 'react';
import { FiMail, FiMessageSquare, FiTag } from 'react-icons/fi';
import { TabHub } from '../../components/Hubs/TabHub';
import InquiryListTab from './CommunicationHub/InquiryListTab';
const CommunicationHub = () => {
    const [activeTab, setActiveTab] = useState('all');
    const tabs = [
        {
            id: 'all',
            label: 'All Messages',
            description: 'View all inquiries',
            icon: _jsx(FiMail, { size: 20 }),
            component: _jsx(InquiryListTab, {}),
        },
        {
            id: 'contact',
            label: 'Contact Inquiries',
            description: 'Website contact form',
            icon: _jsx(FiMessageSquare, { size: 20 }),
            component: _jsx(InquiryListTab, { inquiryTypeFilter: "contact" }),
        },
        {
            id: 'price',
            label: 'Price Inquiries',
            description: 'Diamond price requests',
            icon: _jsx(FiTag, { size: 20 }),
            component: _jsx(InquiryListTab, { inquiryTypeFilter: "price_inquiry" }),
        },
    ];
    return (_jsx(TabHub, { title: "Communication Center", subtitle: "Manage contact inquiries and diamond price requests", activeTab: activeTab, tabs: tabs, onTabChange: setActiveTab }));
};
export default CommunicationHub;
